import api from '@/api/jobCustomField'

const state = {

}

const actions = {
  searchJobCustomField ({ commit }, params) {
    return api.searchJobCustomField(params)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
